import { matchPath } from 'react-router-dom';

export const customMatchPath = (patterns, pathname) => {
    if(typeof patterns === "string"){
        return matchPath(pathname, patterns);
    }
    for (const pattern of patterns) {
        const match = matchPath(pathname, pattern);
        if (match) {
            return match;
        }
    }
    return null;
};